import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-top",
  "use": "icon-top-usage",
  "viewBox": "0 0 78.54 47.56",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 78.54 47.56\" id=\"icon-top\"><defs><style>#icon-top .cls-1{fill:#004727;}</style></defs><path class=\"cls-1\" d=\"M74.48,48c4.11,0,6.44-5.82,3.45-9L43.46,2a4.54,4.54,0,0,0-6.89,0L2.1,39c-3.07,3.29-.51,9,3.49,9Z\" transform=\"translate(-0.74 -0.44)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol